// extracted by mini-css-extract-plugin
export default {"root":"by-ranges-search_root__u14eV","action":"by-ranges-search_action__zJcUg"};